import BaseClass from "../BaseClass.js";


export default class InputRequiredError extends BaseClass {

    constructor(element) {
        super(element);

        this.init();
    }

    init() {
        let $errorMessagesInput = this.$element.first();

        $errorMessagesInput.on('invalid', $.proxy(this.customValidity, this));

        $errorMessagesInput.on('input', $.proxy(this.clearCustomValidity, this));
    }

    customValidity() {
        const errorMessage = this.$element.data('error');
        this.element.setCustomValidity(errorMessage);
    }

    clearCustomValidity() {
        this.element.setCustomValidity('');
    }

    destroyListener() {
        this.$element.off('invalid', $.proxy(this.customValidity, this));
        this.$element.off('input', $.proxy(this.clearCustomValidity, this));
    }
}